module.exports = __webpack_public_path__ + "img/resume_img_have.cc425fe5.png";